export enum ExternalNumberType {
    REGULAR = "Обычный", BRONZE = "Бронзовый", SILVER = "Серебряный", GOLD = "Золотой", DYNAMIC_CALL_TRACKING = "Динамический Колл-Трекинг"
}
